export const COLORS = {
  // Primary Colors
  primary: {
    darkBlue: '#274791',
    mediumBlue: '#4478B9',
    lightBlue: '#4FAADD',
  },
  
  // Accent Colors
  accent: {
    orange: '#E36D34',  // DePaul Highlight
    red: '#D62B2A',
    gold: '#F6B33E',
    yellow: '#FCE58E',
  },
  
  // Supporting Colors
  supporting: {
    turquoise: '#84CBBF',
    mint: '#B9DFCC',
  },
  
  // Gradients for charts
  chartGradients: {
    blues: ['#274791', '#4478B9', '#4FAADD'],
    greens: ['#84CBBF', '#B9DFCC'],
    warm: ['#E36D34', '#F6B33E', '#FCE58E'],
  },
  
  // Semantic Colors
  semantic: {
    success: '#84CBBF',
    warning: '#F6B33E',
    error: '#D62B2A',
    info: '#4FAADD',
  },
  
  // Text Colors
  text: {
    primary: '#304758',
    secondary: '#64748B',
    muted: '#94A3B8',
  },
  
  // Background Colors
  background: {
    light: '#FFFFFF',
    subtle: '#F8FAFC',
    muted: '#F1F5F9',
  },
  
  // Border Colors
  border: {
    light: '#E2E8F0',
    default: '#CBD5E1',
    dark: '#94A3B8',
  }
}; 